import { LotteryInfoGameRoomState } from './lotterySlice';
import { RootState } from '../../../app';

export const selectLottery = (state: RootState) => state.lottery;

export const selectLotteryInfo = (state: RootState) => state.lottery.info;

export const selectLotteryLoading = (state: RootState) => state.lottery.loading;

export const selectLotteryError = (state: RootState) => state.lottery.error;

export const selectLotteryFocusedGameRoomId = (state: RootState) =>
  state.lottery.focusedGameRoomId;

export const selectLotteryNoGamesAnimation = (state: RootState) =>
  state.lottery.noGamesAnimation;

export const selectLotteryNoFocused = (state: RootState) => state.lottery.noFocused;

export const selectLotteryLotteryGameRoomsShort = (state: RootState) =>
  state.lottery.lotteryGameRoomsShort;

export const selectLotteryLotterySessions = (state: RootState) =>
  state.lottery.lotterySessions;

export const selectGameRoomInfoById = (
  state: RootState,
  gameRoomId?: string,
): LotteryInfoGameRoomState | null =>
  gameRoomId ? state.lottery.lotterySessions[gameRoomId] ?? null : null;
